import { provideNzIcons } from 'ng-zorro-antd/icon';
import { IcIcons } from 'libs/core/src/lib/configs/icons';
import { AdminProductService } from 'libs/core/src/lib/services/product.service';
import { AuthService } from 'libs/core/src/lib/services/auth.service';
import { BrokerUserManagementService } from 'libs/core/src/lib/services/broker-user-management.service';
import { IcHttpConfigInterceptor } from 'libs/core/src/lib/interceptors/ic-http-interceptor.interceptor';
import { provideDarkMode } from 'libs/core/src/lib/services/dark-mode.service';
import { providePortalName } from 'libs/core/src/lib/services/notice.service';
import { provideImpersonationMode } from 'libs/core/src/lib/services/impersonation.service';
import { provideImpersonationReadOnlyMode } from 'libs/core/src/lib/interceptors/impersonation-read-only.interceptor';
import { IProductsServiceToken } from 'libs/core/src/lib/services/products.service';
import { IReceiptsInjectionToken } from 'libs/core/src/lib/services/shared-receipt.service';
import { IUsersServiceInjectionToken } from 'libs/core/src/lib/services/users.service';
import { provideTenantTheme } from 'libs/core/src/lib/services/tenant-config.service';
import { RouteTitleStrategy } from 'libs/core/src/lib/route-title-stratagy';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalService } from 'ng-zorro-antd/modal';
import { BrokerReceiptsService } from './app/services/intermediary-receipts.service';
import { BrokerAuthService } from './app/services/broker-auth-service';
import { provideRouter, Route, TitleStrategy } from '@angular/router';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { loginGuard } from './app/login.guard';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgHttpCachingModule } from 'ng-http-caching';
import { IcHttpCachingConfig } from 'libs/core/src/lib/configs/http-cache';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { AppComponent } from './app/app.component';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {
  initializeSentry,
  provideSentryTracing,
} from '../../../libs/core/src/lib/sentry';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';


const routes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('libs/shared-modules/src/lib/login/login.module').then((m) => m.LoginModule),
    title: 'Login',
    data: { portal: 'Broker portal' },
  },
  {
    path: 'dashboard',
    canActivate: [loginGuard],
    loadChildren: () =>
      import('./app/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
];
initializeSentry('Broker Portal');

bootstrapApplication(AppComponent, {
  providers: [
    providePortalName('broker-portal'),
    provideNzIcons(IcIcons),
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      LoadingBarModule,
      LoadingBarHttpClientModule,
      NgHttpCachingModule.forRoot(IcHttpCachingConfig),
      LoadingBarRouterModule,
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IcHttpConfigInterceptor,
      multi: true,
    },
    { provide: NZ_I18N, useValue: en_US },
    { provide: NzNotificationService },
    { provide: NzModalService },
    { provide: TitleStrategy, useClass: RouteTitleStrategy },
    {
      provide: IReceiptsInjectionToken,
      useClass: BrokerReceiptsService,
    },
    {
      provide: IUsersServiceInjectionToken,
      useClass: BrokerUserManagementService,
    },
    {
      provide: AuthService,
      useClass: BrokerAuthService,
    },
    provideImpersonationMode(),
    provideImpersonationReadOnlyMode(),
    provideTenantTheme(),
    provideDarkMode(),
    { provide: IProductsServiceToken, useClass: AdminProductService },
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
     provideSentryTracing(), provideNzDateFnsAdapter(),
  ],
}).catch((err) => console.error());
